import React, { useState } from 'react';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Icon from '@material-ui/core/Icon';
import { makeStyles } from '@material-ui/core/styles';
import auth from './auth-helper';
import { Navigate, Link, useLocation } from 'react-router-dom';
import { signin } from './api-auth';

const useStyles = makeStyles(theme => ({
  card: {
    maxWidth: 600,
    margin: 'auto',
    textAlign: 'center',
    marginTop: theme.spacing(5),
    paddingBottom: theme.spacing(2)
  },
  error: {
    verticalAlign: 'middle'
  },
  title: {
    marginTop: theme.spacing(2)
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 300
  },
  submit: {
    margin: 'auto',
    marginBottom: theme.spacing(2),
    padding: theme.spacing(2),
    fontSize: '1.2rem',
    width: '300px',
  },
  resetButton: {
    marginLeft: 'auto',
    marginRight: theme.spacing(2),
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(1),
    fontSize: '0.6rem',
  },
  note: {
    marginTop: theme.spacing(2),
    color: 'red',
    fontWeight: 'bold',
  },
  password: {
    marginTop: theme.spacing(1),
  }
}));

const SignIn: React.FC = () => {
  const location = useLocation();
  const classes = useStyles();
  const [values, setValues] = useState({
    username: '',
    password: '',
    error: '',
    redirectToReferrer: false
  });

  const clickSubmit = () => {
    const user = {
      username: values.username,
      password: values.password
    };
    signin(user).then((data) => {
      if (data.error) {
        setValues({ ...values, error: data.error });
      } else {
        auth.authenticate(data, () => {
          setValues({ ...values, error: '', redirectToReferrer: true });
        });
      }
    });
  };

  const handleChange = (name: string) => (event: React.ChangeEvent<HTMLInputElement>) => {
    setValues({ ...values, [name]: event.target.value });
  };

  const { from } = location.state || { from: { pathname: '/' } };
  const { redirectToReferrer } = values;

  if (redirectToReferrer) {
    return <Navigate to={from} />;
  }

  return (
    <Card className={classes.card}>
      <CardContent>
        <Typography variant="h6" className={classes.title}>
          Sign In
        </Typography>
        <TextField id="username" type="username" label="username" className={classes.textField} value={values.username} onChange={handleChange('username')} margin="normal"/><br/>
        <TextField id="password" type="password" label="Password" className={classes.textField} value={values.password} onChange={handleChange('password')} margin="normal"/>
        <br/> {
          values.error && (<Typography component="p" color="error">
            <Icon color="error" className={classes.error}>error</Icon>
            {values.error}
          </Typography>)
        }
      </CardContent>
      <CardActions>
        <Button color="primary" variant="contained" onClick={clickSubmit} className={classes.submit}>LOG IN</Button>
      </CardActions>
      <Link to="/user/passwordreset">
        <Button color="primary" variant="contained">
          Reset Password
        </Button>
      </Link>
      <Typography variant="body2" >
        <span className={classes.note}>Note:</span> Demo Account(s): test1@survey.com, test2@survey.com, test3@survey.com
      </Typography>
      <Typography variant="body2" className={classes.password}>
        Password: survey123
      </Typography>
    </Card>
  );
};

export default SignIn;
